module.exports = __webpack_public_path__ + "a0f659e4252b472fb6c907367dfcef22.svg";